<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="设备编号">
            <a-input v-model="searchP.deviceno" style="width:400px;" placeholder="设备编号"></a-input>
        </a-form-item>

        <a-form-item label="是否在线">
            <a-select  v-model="searchP.isonline" style="width:100px" placeholder="是否在线" >
                <a-select-option key="">全部</a-select-option>
                <a-select-option key="1">在线</a-select-option>
                <a-select-option key="0">离线</a-select-option>

            </a-select>
         </a-form-item>
        <a-form-item label="创建时间">
            <a-range-picker
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>


export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                deviceno:'',
                isonline:'',
                starttime:'',
                endtime:'',

            },
        }
    },
    
    methods:{
        onChange(v,t){
            this.searchP.starttime = t[0];
            this.searchP.endtime = t[1]
            console.log(this.timeRange)
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
        handleChange(item){
            this.searchP.passwaytype = item.passwaytype;
        },
    },
    mounted(){

        let query = this.$route.query;
        this.searchP.deviceno = query.deviceno ? query.deviceno : '';
        this.handleSubmit()
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

